import * as React from 'react';
import Heading from '@telia-front/heading';
const categoryHeadingBEM = (className) => {
    const classArray = ['product-comparison__category-heading', 'h4', 'text-left'];
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
};
const CategoryHeading = (props) => {
    const { label } = props;
    return (React.createElement(Heading, { element: "h2", className: categoryHeadingBEM(typeof label === 'string' ? undefined : 'text-size-normal') },
        React.createElement("span", { className: "product-comparison__category-heading-content" }, label)));
};
export default CategoryHeading;
